import React from 'react'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Outlet, Link } from "react-router-dom";
import { IntlProvider, FormattedMessage } from "react-intl";
import { useSelector, useDispatch } from 'react-redux'
import Sidebar from '../components/commonComp/Sidebar';
import Footer from '../components/commonComp/Footer';
import enMessages from '../utility/language/english.json'
import koMessages from '../utility/language/korean.json'
import trMessages from '../utility/language/turkish.json'
import Header from '../components/commonComp/Header';
import Login from './Login';

const Home = () => {

    const languageState = useSelector((state) => state.languageState);
    let languageCode = languageState.active_language.language_code;

    const userDetailState = useSelector((state) => state.userDetailState);
    const user = userDetailState?.user_details;

    const allMessages = {
        en: enMessages,
        ko: koMessages,
        tr: trMessages,
    }

    let messages = allMessages[languageCode]

    if (!user) {
        return (
            <IntlProvider messages={messages} locale={languageCode} defaultLocale={languageCode} >
                 <ToastContainer />
                 <Login />
            </IntlProvider>
        )
    }

    return (
        <IntlProvider messages={messages} locale={languageCode} defaultLocale={languageCode} >
        <section className="main">
             <ToastContainer />
             <Sidebar />
            <section className="home">
                <Header />

                <Outlet />
                <Footer />
            </section>
      
        </section>
        </IntlProvider>
  )
}

export default Home